import React from 'react';
import PropTypes, { object, string } from 'prop-types';
import cn from 'classnames';

import { Text } from '../../../Elements';

import classes from './PlaceholderPart.module.scss';

const PlaceholderPart = props => {
  const { value, placeholder, menuIsOpen, styleStartModeSmall } =
    props.selectProps;

  if (!menuIsOpen && styleStartModeSmall) {
    return (
      <Text size={4} className={classes.name}>
        {placeholder}
      </Text>
    );
  }

  return (
    <div className={cn(classes.placeholder)}>
      <Text
        size={4}
        className={cn(
          classes.text,
          value && (value.length > 0 || value.label) && classes.text_select
        )}
      >
        {value && value.length > 0
          ? value
              .map(item =>
                item && item.placeholderName
                  ? item.placeholderName
                  : item && item.label
                  ? item.label
                  : placeholder
              )
              .join(', ')
          : placeholder}
      </Text>
      {value.length > 0 && (
        <Text className={classes.counter}>{value.length}</Text>
      )}
    </div>
  );
};

PlaceholderPart.propTypes = {
  selectProps: PropTypes.object,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(string),
    PropTypes.arrayOf(object)
  ])
};

export default PlaceholderPart;
